import { z } from 'zod';
import { yesNoRequired } from '@utils/form-schema';

export const acceptTransfusionsSchema = z.object({
    willAcceptTransfusions: yesNoRequired,
});
